import { render, staticRenderFns } from "./DocVideoDetectionNew.vue?vue&type=template&id=2d80c744&scoped=true"
import script from "./DocVideoDetectionNew.vue?vue&type=script&lang=js"
export * from "./DocVideoDetectionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d80c744",
  null
  
)

export default component.exports